module.exports = __webpack_public_path__ + "img/animal_health_encyclopedia.bfc09ef6.png";